import { FilterDescriptor } from '@progress/kendo-data-query';

export class FilterDescriptorDDLs implements FilterDescriptor {
  field?: string | Function;
  operator: string | Function;
  value?: any;
  ignoreCase?: boolean;

  dropDownList?: any[];
  dropDownListSource?: any[];
  title?: string;
  checked?: boolean;

  constructor(filter: FilterDescriptor) {
    this.field = filter.field;
    this.operator = filter.operator;
    this.value = filter.value;
    this.ignoreCase = filter.ignoreCase;
  }

  static mapToFilterDescriptor(thisT: FilterDescriptorDDLs): FilterDescriptor {
    thisT.field = thisT.field == 'EventDate' ? 'StatusLastChange' : thisT.field;
    return {
      field: thisT.field,
      operator: thisT.operator,
      value: thisT.value,
      ignoreCase: thisT.ignoreCase,
    };
  }

  static mapToFilterDescriptors(
    list: FilterDescriptorDDLs[]
  ): FilterDescriptor[] {
    return list.map((x) => FilterDescriptorDDLs.mapToFilterDescriptor(x));
  }
}
